import { Children, cloneElement } from 'react';
import ComponentHeaderRightSideActions, { ComponentHeaderRightSideOptions } from '../../Components/Form/Inputs/ComponentMoreOptionsHorizontalDots';
import LabelWithTooltip from '../../Components/Form/Inputs/LabelWithTooltip';
import ComponentHeader from '../../Components/Headers/ComponentHeader';
import styles from './DragAndDropWrapper.module.scss';

export interface IDashboardNonChartWrapperProps {
    children: JSX.Element;
    customTitle?: string;
    dragIndicatorIcon?: React.ReactNode;
    isInDashboardEditMode?: boolean;
    maximizeMinimizeButton?: ComponentHeaderRightSideOptions.Maximize | ComponentHeaderRightSideOptions.Minimize;
    name: string; // Internal name of the component.
    title?: string;
    titleWithTooltip?: string;
    useDynamicHeight?: boolean;
    handleMoreOptionsSelection: (value: ComponentHeaderRightSideOptions) => void;
}

const DashboardNonChartWrapper: React.FC<IDashboardNonChartWrapperProps> = (props: IDashboardNonChartWrapperProps) => {
    const containerClassName = props.useDynamicHeight
        ? styles.dragAndDrop_non_chart_wrapper_container_dynamic_height
        : styles.dragAndDrop_non_chart_wrapper_container;

    const contentAreaClassName = props.useDynamicHeight
        ? styles.dragAndDrop_non_chart_wrapper_content_area_dynamic_height
        : styles.dragAndDrop_non_chart_wrapper_content_area;

    return (
        <div className={containerClassName}>
            <div className={styles.dragAndDrop_non_chart_wrapper_actions_row}>
                <div className={styles.dragAndDrop_non_chart_wrapper_left_side}>
                    {props.dragIndicatorIcon && <div>{Children.only(props.dragIndicatorIcon)}</div>}
                    {props.titleWithTooltip ? (
                        <LabelWithTooltip
                            title={<ComponentHeader title={props.customTitle ?? props.title} useContainerFontSize />}
                            tooltip={props.titleWithTooltip}
                            placement="right-end"
                        />
                    ) : (
                        <ComponentHeader title={props.customTitle ?? props.title} useContainerFontSize />
                    )}
                </div>
                <div>
                    {props.isInDashboardEditMode && (
                        <ComponentHeaderRightSideActions
                            name={props.name}
                            isInDashboardEditMode={props.isInDashboardEditMode}
                            maximizeMinimizeButton={props.maximizeMinimizeButton}
                            hideDownload
                            hidePopoutModal
                            handleMoreOptionsSelection={props.handleMoreOptionsSelection}
                            track={{ eventCategory: 'Dashboard', eventAction: 'MoreOptionsClicked' }}
                        />
                    )}
                </div>
            </div>
            <div className={contentAreaClassName}>{cloneElement(Children.only(props.children), { useDynamicHeight: props.useDynamicHeight })}</div>
        </div>
    );
};

export default DashboardNonChartWrapper;
